import React from 'react'
import { Document, Page } from 'react-pdf'
import { Loader2 } from 'lucide-react'

interface DocumentPreviewThumbnailsProps {
	url: string
	numPages: number
	currentPage: number
	onSelectPage: (page: number) => void
}

const THUMB_WIDTH = 130

const DocumentPreviewThumbnails: React.FC<DocumentPreviewThumbnailsProps> = ({
	url,
	numPages,
	currentPage,
	onSelectPage,
}) => {
	if (!numPages || numPages < 2) return null

	return (
		<div className="h-full overflow-y-auto bg-gray-50 border-r border-gray-200">
			<Document
				file={url}
				loading={
					<div className="flex items-center justify-center h-full text-gray-400 p-6">
						<Loader2 className="w-5 h-5 animate-spin" />
					</div>
				}
			>
				<div className="flex flex-col gap-2 p-3">
					{Array.from({ length: numPages }).map((_, i) => {
						const pageNumber = i + 1
						const isActive = pageNumber === currentPage
						return (
							<button
								key={pageNumber}
								type="button"
								onClick={() => onSelectPage(pageNumber)}
								className={[
									'flex flex-col items-center gap-1 rounded-md p-1 transition-colors bg-transparent border-0 cursor-pointer',
									isActive
										? 'bg-[#0080fe]/10 ring-2 ring-[#0080fe]'
										: 'hover:bg-gray-200',
								].join(' ')}
								aria-label={`Go to page ${pageNumber}`}
								aria-current={isActive ? 'page' : undefined}
							>
								<Page
									pageNumber={pageNumber}
									width={THUMB_WIDTH}
									renderTextLayer={false}
									renderAnnotationLayer={false}
									className="shadow-sm"
								/>
								<div
									className={[
										'text-[11px] font-medium',
										isActive ? 'text-[#0080fe]' : 'text-gray-600',
									].join(' ')}
								>
									{pageNumber}
								</div>
							</button>
						)
					})}
				</div>
			</Document>
		</div>
	)
}

export default DocumentPreviewThumbnails
